 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Document Name
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryAddrToFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryAddrToFilterForm"
                            v-model="filtersAddrTo.addressedTo"
                            :label="filtersAddrToLabel.addressedTo"
                            :error-messages="errors.collect('filterAddrTo')"
                            data-vv-name="filterAddrTo"
                            :data-vv-as="filtersAddrToLabel.addressedTo"
                            v-validate="'entry|max:200'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearAddrToFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doAddrToFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="addrToHeaders"
          :items="addrToItems"
          v-bind:options.sync="paginationAddrTo"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsAddrTo"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.docName }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignAddressedTo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr></template
          >
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      paginationAddrTo: {
        page: 1
      }
    }
  },
  mounted() {
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.doClearAddrToFilters()
      }
    },
    'paginationAddrTo': function(value) {
      this.doClearAddrToFilters()
    }
  },
  methods: {
    closeDialog() {
      this.filtersAddrTo.addressedTo = ''
      this.$emit('close')
    },
    doClearAddrToFilters() {
      this.filtersAddrTo.addressedTo = ''
      this.fetchAddrToData()
    },
    doAddrToFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryAddrToFilterForm').then((result) => {
        if (result) {
          this.paginationAddrTo.page = 1
          this.fetchAddrToData()
        }
      })
    },
    assignAddressedTo(data) {
      // Use $emit to call parent Accounts page method assignAddressedTo and pass the value
      this.$emit('assign-addressed-to', data.docName)
      this.$emit('close')
    }
  },
  computed: {},
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    }
  },
  mixins: [TableConst.default, accountsFilters, commonAjaxMixin]
}
</script>
